import FileInput from '../../Components/FileInput';
import Header from '../../Components/Header';
import TextInput from '../../Components/TextInput';
import { useAssignResourcesPage } from './useAssignResourcesPage';

const AssignResourcesPage = () => {
	const {
		form,
		setForm,
		handleFileChange,
		handleSubmit,
		errors,
		assignedResources,
		notFoundResources,
		apiMessage,
	} = useAssignResourcesPage();
	return (
		<>
			<Header />{' '}
			<div className='flex flex-col items-center'>
				<div className='content w-full max-w-[1000px] flex flex-col items-center pb-20'>
					<h1 className='text-3xl font-bold pt-8 pb-12'>
						ASSIGN RESOURCES TO OLIB
					</h1>

					<form action='#' className='w-[500px] flex flex-col gap-y-8'>
						<TextInput
							onChange={(e) =>
								setForm({ ...form, institutionCode: e.target.value })
							}
							value={form.institutionCode}
							label='Institution Code'
						/>
						{errors.institutionCode && (
							<p className='text-red-500'>Please enter an institution code.</p>
						)}
						<FileInput
							onChange={handleFileChange}
							fileName={form?.csvFile?.name}
						/>
						{errors.csvFile && (
							<p className='text-red-500'>Please upload a valid CSV file.</p>
						)}
						<button className='buttonTest w-full' onClick={handleSubmit}>
							Assign Resources
						</button>
					</form>

					{apiMessage && (
						<div className='text-center rounded-md mt-4 p-4 text-lg font-medium bg-slate-100'>
							{apiMessage}
						</div>
					)}
					{assignedResources.length > 0 && (
						<div className='assigned-resources'>
							<h2 className='text-xl font-semibold mb-4 mt-16'>
								Assigned Resources
							</h2>
							<ul className='flex flex-wrap gap-4'>
								{assignedResources.map((resource) => (
									<li
										className='rounded-md shadow-md border border-gray-200 w-[300px] cursor-pointer hover:scale-[1.05] duration-75 bg-white'
										key={resource.id}
										onClick={() => window.open(resource.url, '_blank')}
									>
										<div className='img'>
											<img
												src={resource.image}
												alt=''
												className='w-full h-[150px] object-contain p-5 pb-0 '
											/>
										</div>
										<div className='content p-5'>
											<div className='title font-medium text-base pt-4 overflow-hidden h-[43px]'>
												{resource.title}
											</div>
											<div className='category text-sm pt-4'>
												{resource.program}
											</div>
										</div>
									</li>
								))}
							</ul>
						</div>
					)}

					{notFoundResources.length > 0 && (
						<div className='assigned-resources mt-20'>
							<h2 className='text-xl font-semibold mb-4 mt-16'>
								Resources not found
							</h2>
							<ul className='flex flex-wrap gap-4'>
								{notFoundResources.map((resource, index) => (
									<li
										className='rounded-md shadow-md border border-gray-200 w-full p-4 text-wrap cursor-pointer hover:scale-[1.05] duration-75 bg-white'
										key={index}
										onClick={() => window.open(resource, '_blank')}
									>
										{resource}
									</li>
								))}
							</ul>
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default AssignResourcesPage;
